<template>
  <v-dialog :value="value" @input="$emit('input', $event)" max-width="800px">
    <v-card class="session-dialog-card">
      <v-toolbar class="elevation-2" color="primary">
        <v-toolbar-title class="ml-0">
          <span class="font-weight-bold white--text">
            {{ $t('coinHistory.sessionTitle') }}
          </span>
        </v-toolbar-title>
        <v-spacer />
        <v-btn @click="close" icon dark>
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text class="px-0 pb-0 session-dialog-content">
        <v-container>
          <v-card v-if="session" class="pb-2">
            <v-simple-table class="do-not-apply-hover" dense>
              <template v-slot:default>
                <tbody>
                  <tr>
                    <td>{{ $t('entities.users.attributes.username') }}</td>
                    <td class="font-weight-bold">
                      {{ session.user ? session.user.username : '—' }}
                    </td>
                    <td>{{ $t('entities.invoices.attributes.id') }}</td>
                    <td class="font-weight-bold">{{ session.id }}</td>
                  </tr>
                  <tr>
                    <td>{{ $t('entities.devices.entity') }}</td>
                    <td class="font-weight-bold">
                      {{ session.device ? session.device.hostname : '—' }}
                    </td>
                    <td></td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>{{ $t('entities.sessions.attributes.startedAt') }}</td>
                    <td class="font-weight-bold">
                      {{ formatDateValue(session.started_at) }}
                    </td>
                    <td>{{ $t('entities.sessions.attributes.stoppedAt') }}</td>
                    <td class="font-weight-bold">
                      {{ formatDateValue(session.stopped_at) }}
                    </td>
                  </tr>
                  <tr>
                    <td>{{ $t('entities.sessions.attributes.duration') }}</td>
                    <td class="font-weight-bold">
                      {{ formatDuration(session.duration) }}
                    </td>
                    <td>{{ $t('entities.sessions.attributes.cost') }}</td>
                    <td class="font-weight-bold">
                      {{ session.cost }} <CoinIcon />
                    </td>
                  </tr>
                  <tr>
                    <td>{{ $t('coinHistory.xpGained') }}</td>
                    <td class="font-weight-bold">{{ session.xp_gained }}</td>
                    <td></td>
                    <td></td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card>

          <v-card v-if="games.length" class="mt-4 pb-2">
            <v-card-title class="pb-2">
              {{ $t('entities.games.title') }}
            </v-card-title>
            <v-simple-table dense>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left">
                      {{ $t('entities.games.title') }}
                    </th>
                    <th class="text-left">
                      {{ $t('entities.sessions.attributes.startedAt') }}
                    </th>
                    <th class="text-left">
                      {{ $t('entities.sessions.attributes.duration') }}
                    </th>
                    <th class="text-left">
                      {{ $t('entities.sessions.attributes.stoppedAt') }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(sessionGame, index) in games" :key="index">
                    <td>
                      <div class="d-flex align-center my-1">
                        <v-avatar size="28px" class="mr-2">
                          <img
                            v-if="
                              sessionGame.game &&
                              (sessionGame.game.icon || sessionGame.game.image)
                            "
                            :src="
                              sessionGame.game.icon || sessionGame.game.image
                            "
                            alt="" />
                          <v-icon v-else color="warning" small>
                            mdi-alert
                          </v-icon>
                        </v-avatar>
                        <span>
                          {{
                            sessionGame.game
                              ? sessionGame.game.name
                              : $t('entities.games.unknownGame')
                          }}
                        </span>
                      </div>
                    </td>
                    <td>{{ formatDateValue(sessionGame.started_at) }}</td>
                    <td>{{ formatDuration(sessionGame.duration) }}</td>
                    <td>
                      {{ formatDateValue(sessionGame.duration_updated_at) }}
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card>
        </v-container>
      </v-card-text>
      <v-card-actions class="session-dialog-actions">
        <v-spacer />
        <v-btn @click="close" color="dark darken-1" text>
          {{ $t('miscellaneous.ok') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import formatDate from '@/mixins/format-date'
import CoinIcon from '@/components/CoinIcon.vue'

export default {
  name: 'CoinSessionDialog',
  components: { CoinIcon },
  mixins: [formatDate],
  props: {
    value: { type: Boolean, default: false },
    session: { type: Object, default: null },
  },
  computed: {
    games() {
      return this.session?.games || []
    },
  },
  methods: {
    close() {
      this.$emit('input', false)
    },
    formatDateValue(value) {
      if (!value) return '—'
      const parsed = new Date(value)
      if (Number.isNaN(parsed.getTime())) return value
      return this.formatDate(parsed, true, true)
    },
    formatDuration(seconds) {
      if (seconds == null) return '—'
      const total = Math.floor(Number(seconds))
      if (!Number.isFinite(total) || total < 0) return String(seconds)
      const hours = Math.floor(total / 3600)
      const mins = Math.floor((total % 3600) / 60)
      const secs = total % 60
      const parts = []
      if (hours) parts.push(`${hours}h`)
      if (mins) parts.push(`${mins}m`)
      if (secs) parts.push(`${secs}s`)
      return parts.join(' ') || '0s'
    },
  },
}
</script>

<style scoped>
.session-dialog-card {
  display: flex;
  flex-direction: column;
  max-height: 90vh;
}

.session-dialog-content {
  flex: 1 1 auto;
  overflow-y: auto;
  min-height: 0;
}

.session-dialog-actions {
  flex: 0 0 auto;
}
</style>
